import { createContext } from 'react'

export type BugReportContextValue = {
  openBugReport: () => Promise<void>
}

export const BugReportContext = createContext<BugReportContextValue | null>(null)


